import { useStaticQuery, graphql } from 'gatsby'

export const useWhyHirschbergQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query WhyHirschbergQuery {
      wpPage(title: { eq: "Home" }) {
        whyHirschberg {
          whyHirschberg {
            backgroundImageMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, quality: 100, formats: [WEBP])
                }
              }
            }
            backgroundImageDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, quality: 100, formats: [WEBP])
                }
              }
            }
            listIcon {
              localFile {
                publicURL
              }
            }
            title
            tabs {
              icon {
                localFile {
                  publicURL
                }
              }
              label
              labelMobile
              image1 {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: [WEBP], sizes: "(min-width: 1024px) 32vw, 64vw")
                  }
                }
              }
              image2 {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: [WEBP], sizes: "(min-width: 1024px) 22vw, 41vw")
                  }
                }
              }
              title
              content
              link {
                title
                url
              }
              subitems {
                label
                content
              }
            }
          }
        }
      }
    }
  `)
  return wpPage.whyHirschberg.whyHirschberg
}
